'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by zfc on 2017/10/25.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import {GoeasyCarousel, HomePageSearchBar, NewMediumListInfo, HomePagingBar, HomePageOrderBar, ListPageMiddleFlip} from 'components';
// import {connect} from 'react-redux';
// import { push } from 'react-router-redux';
// import * as newMediumAction from 'redux/modules/newMedium';
// import { asyncConnect } from 'redux-async-connect';
// import Collapse from 'react-collapse';
// import {changeHeaderText} from 'redux/modules/background';
/* @asyncConnect([{
 promise: ({store: {dispatch, getState}, location}) => {
 const promises = [];
 const query = location.query;
 let filter = '';
 let page = null;
 let orderItem = '';
 let direction = '';
 if (query.shop) {
 filter = {...filter, shopId: query.shop};
 }
 if (query.page) {
 page = query.page;
 }
 if (query.findValue) {
 filter = {...filter, FindValue: query.findValue};
 }
 if (query.orderItem) {
 orderItem = query.orderItem;
 }
 if (query.direction) {
 direction = query.direction;
 }
 promises.push(dispatch(changeHeaderText('新媒体')));
 promises.push(dispatch(newMediumAction.load(filter, {
 orderItem,
 direction
 }, newMediumAction.isLoaded(getState()), page)));
 return Promise.all(promises);
 }
 }])
 @connect(
 state => ({
 data: state.newMedium.data,
 dataError: state.newMedium.error
 }), {
 ...newMediumAction,
 routerPush: push
 }
 ) */
var NewMediumCenter = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(NewMediumCenter, _Component);

  // routerPush: PropTypes.func

  function NewMediumCenter() {
    (0, _classCallCheck3.default)(this, NewMediumCenter);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(NewMediumCenter).call(this));

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(NewMediumCenter, [{
    key: 'render',
    value: function render() {
      var styles = require('./NewMediumCenter.scss');
      var middleImages = [{ img: 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/zmbg1.jpg' }, { img: 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/zmbg1.jpg' }, { img: 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/zmbg1.jpg' }];
      var carouselDiv = _react2.default.createElement(_components.GoeasyCarousel, { page: 'mainOther', images: middleImages });

      return _react2.default.createElement(
        'div',
        null,
        carouselDiv,
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(
          'div',
          { className: styles.zm_box },
          _react2.default.createElement(
            'div',
            { className: styles.zm_box_float },
            _react2.default.createElement(
              'a',
              { href: 'zmt_yfzx.html' },
              _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/zmbg2.jpg', alt: '' })
            ),
            _react2.default.createElement('div', { className: 'clear' }),
            _react2.default.createElement(
              'a',
              { href: 'chanpinzhongxin.html', className: styles.zm_box_mt },
              _react2.default.createElement('img', {
                src: 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/zmbg3.jpg', alt: '' })
            )
          ),
          _react2.default.createElement(
            'a',
            { href: 'zmt_ddjs.html' },
            _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/zmbg4.jpg', alt: '',
              className: styles.zm_box_float + ' ' + styles.zm_box_ml })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.zm_box_float },
            _react2.default.createElement(
              'a',
              { href: 'zmt_ddtj.html', className: styles.zm_box_ml },
              _react2.default.createElement('img', {
                src: 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/zmbg5.jpg', alt: '' })
            ),
            _react2.default.createElement('div', { className: 'clear' }),
            _react2.default.createElement(
              'a',
              { href: 'zmt_zlsz.html',
                className: styles.zm_box_ml + ' ' + styles.zm_box_float + ' ' + styles.zm_box_mt },
              _react2.default.createElement('img', {
                src: 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/zmbg6.jpg', alt: '', className: styles.zm_box_float })
            ),
            _react2.default.createElement(
              'a',
              { href: '##', className: styles.zm_box_ml + ' ' + styles.zm_box_float + ' ' + styles.zm_box_mt },
              _react2.default.createElement('img', {
                src: 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/zmbg7.jpg', alt: '', className: styles.zm_box_float })
            )
          )
        )
      );
    }
  }]);
  return NewMediumCenter;
}(_react.Component), _class.propTypes = {
  children: _react.PropTypes.object,
  location: _react.PropTypes.object,
  data: _react.PropTypes.object }, _temp);
exports.default = NewMediumCenter;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/NewMediumCenter/NewMediumCenter.js
 ** module id = 1503
 ** module chunks = 0
 **/